module.exports = __webpack_public_path__ + "img/chatting.8dda2f83.svg";